<template>
  <div class="table-responsive">
    <div v-if="response_info.VerifyResult == 1">
      <div v-if="response_info.Data.length > 0">
        <div>
          <h4 class="service-response-h4">
            {{ $t("message.find_partner.court_notice_info") }}
          </h4>
        </div>
        <b-table
          :fixed="true"
          :fields="court_notice_list_fields"
          :items="response_info.Data"
        >
          <template v-slot:cell(Id)="data">
            <span class="foldable">{{ data.value }}</span>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: ["data"],
  data() {
    return {
      current_tab: 0,
      loading: false,
      no_results: false,
      response_info: [],
      service_info: {},
      service_info_objects: {},
      court_notice_list_fields: [
        {
          key: "Id",
          label: this.$t("message.find_partner.court_notice_Id"),
        },
        {
          key: "CaseNo",
          label: this.$t("message.find_partner.court_notice_CaseNo"),
        },
        {
          key: "CaseReason",
          label: this.$t("message.find_partner.court_notice_CaseReason"),
        },
        {
          key: "Category",
          label: this.$t("message.find_partner.court_notice_Category"),
        },
        {
          key: "Court",
          label: this.$t("message.find_partner.court_notice_Court"),
        },
        {
          key: "PublishDate",
          label: this.$t("message.find_partner.court_notice_PublishDate"),
        },
        {
          key: "ProsecutorList",
          label: this.$t("message.find_partner.court_notice_ProcecutorList"),
        },
        {
          key: "DefendantList",
          label: this.$t("message.find_partner.court_notice_DefendantList"),
        },
      ],
    };
  },
  mounted() {
    this.response_info = this.data.response_info;
  },
  computed: {},
  watch: {
    data: function (newVal, oldVal) {
      this.response_info = newVal.response_info;
    },
  },
  methods: {
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
  },
};
</script>
